<template>
  <div :class="rootClass" :data-test="dataTest">
    <div class="payment-method-details__content d-flex flex-column gap-1 min-width-0 flex-grow-1 overflow-hidden">
      <div class="d-flex gap-x-2 min-width-0 overflow-hidden">
        <div class="payment-method-details__brand flex-shrink-0">
          <Icon v-if="brandIconName" :name="brandIconName" class="payment-method-details__brand--compact" />
        </div>
        <div class="payment-method-details__primary min-width-0 flex-grow-1">
          <span class="payment-method-details__title font-weight-semi-bold text-capitalize">
            {{ typeLabel }}
          </span>
          <span v-if="detail" class="payment-method-details__detail">{{ detailSeparator }}{{ detail }}</span>
        </div>
      </div>

      <div v-if="secondaryLine" class="payment-method-details__secondary">
        {{ secondaryLine }}
      </div>

      <div v-if="holder" class="payment-method-details__secondary">
        {{ holder }}
      </div>
    </div>

    <div v-if="$slots.trailing" class="payment-method-details__trailing flex-shrink-0">
      <slot name="trailing" />
    </div>
  </div>
</template>

<script lang="ts">
import Icon from '@/components/Icons/Icon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Icon,
  },
})
export default class PaymentMethodDetailsBody extends Vue {
  @Prop({ default: 'default' })
  variant!: 'default' | 'row';

  @Prop({ default: null })
  dataTest!: string | null;

  @Prop({ default: false })
  brandIconName!: string | false;

  @Prop({ required: true })
  typeLabel!: string;

  @Prop({ default: '' })
  detail!: string;

  @Prop({ default: ' ' })
  detailSeparator!: string;

  @Prop({ default: '' })
  secondaryLine!: string;

  @Prop({ default: null })
  holder!: string | null;

  get rootClass(): string | string[] {
    if (this.variant === 'row') {
      return 'payment-method-details payment-method-details--row d-flex align-center justify-space-between min-width-0 w-100 gap-x-2 py-3';
    }
    return 'd-flex align-start min-width-0 gap-x-2';
  }
}
</script>

<style lang="scss" scoped>
.payment-method-details__brand {
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: rgba(map-get($navy, 'base'), 0.32) !important;
  width: 24px;
  margin-top: 4px;

  &--compact {
    font-size: rem(20);
  }
}

.payment-method-details__title {
  color: map-get($lapis, 'lighten-2');
}

.payment-method-details__primary {
  flex: 1 1 0;
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
}

.payment-method-details__detail {
  color: map-get($lapis, 'base');
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.payment-method-details__secondary {
  color: map-get($neutral, 'darken-2');
  font-size: rem(14);
  line-height: rem(14);
}
</style>
